import 'hammerjs'
import './assets/dark'
import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'

import { AppModule } from './app/app.module'
import { issueTracker } from './app/core/errors/issueTracker'
import { environment } from './environments/environment'

if (environment.production) {
  enableProdMode()
}

// before Angular, so that a bootstrap that fails is reported too
issueTracker.start()

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => {
    console.error(err)
    issueTracker.reportHandled(err, 'start the app')
  })
